import React from 'react';
import { Link } from 'react-router-dom';

export default function InfoPage({ eyebrow, title, subtitle, icon, children, aside }) {
  return (
    <div className="page-frame info-page">
      <div className="page-container">
        <div className="info-hero">
          <div className="info-hero-icon" aria-hidden="true">{icon}</div>
          <div className="page-heading compact-heading">
            <div className="eyebrow">{eyebrow}</div>
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
        </div>
        <div className={`info-layout ${aside ? '' : 'single'}`}>
          <article className="info-content">{children}</article>
          {aside && <aside className="info-aside">{aside}</aside>}
        </div>
        <Link to="/" className="back-link"><span>←</span> Back to home</Link>
      </div>
    </div>
  );
}
